export default "__VITE_ASSET__439148f3__"